import {FlexItem, FlexLayout, Text} from '@salt-ds/core';
import '../CommonCard.css';
import Constants from '../../components/common/Constants';
import './SystemMaintainance.css';
import PlannedMaintainance from '../../images/PlannedMaintainance.svg';
import UnplannedMaintainance from '../../images/UnplannedMaintainance.svg';
import {customerServiceLink} from '../../common/ApiUtils';

function OutageSystemMaintainance ({maintenanceType}) {
  const isUnplanned = maintenanceType === "unplanned";

  return(
    <FlexLayout direction="column" align="center" className="outage-page-layout">

      <FlexItem>
        <Text className="page-title">
          {Constants.systemMaintainanceMessage}
        </Text>
      </FlexItem>
      <FlexItem>
        <Text className="page-instruction-text">
            {isUnplanned ? Constants.unplannedOutageMessage : Constants.plannedOutageMessage }
          </Text>
      </FlexItem>
      <FlexItem >
          <img src={isUnplanned ? UnplannedMaintainance : PlannedMaintainance } alt="" className="planned-outage-img"/>
      </FlexItem>
      <FlexItem>
        {isUnplanned &&
        <Text className="page-instruction-text">
          {Constants.unplannedOutageHelpText(customerServiceLink)}
        </Text>}
      </FlexItem>
    </FlexLayout>
  )
}

export default OutageSystemMaintainance;
